import evolutionIcon from '../../../assets/img/shortcut_icon/evolution.png';
import draIcon from '../../../assets/img/draIcon.png';
import allUsers from '../../../assets/img/shortcut_icon/allUsers.png';
import allAppointment from '../../../assets/img/appointment.png';
import newAppointment from '../../../assets/img/consult.png';
import allPersons from '../../../assets/img/shortcut_icon/allPersons.png';
import newPerson from '../../../assets/img/shortcut_icon/newPerson.png';
import allCompanies from '../../../assets/img/shortcut_icon/allCompanies.png';
import newCompany from '../../../assets/img/shortcut_icon/newCompany.png';
import newUser from '../../../assets/img/shortcut_icon/newUser.png';
import allFoods from '../../../assets/img/shortcut_icon/allFoods.png';
import anthropometry from '../../../assets/img/shortcut_icon/anthropometry.png';
import consultation from '../../../assets/img/draIcon.png';

const AccessControl0 = ["Developer"];
const AccessControl1 = ["Developer", "Admin"];
const AccessControl2 = ["Developer", "Admin", "Manager"];
const AccessControl3 = ["Developer", "Admin", "Manager", "Coordinator"];
const AccessControl4 = ["Developer", "Admin", "Manager", "Coordinator", "User"];


export const cardsConfig = [
  // {
  //   imgSrc: allPersons,
  //   label: "Todas as Pessoas",
  //   navigateTo: "/home/person/get",
  //   requiredRole: ["Admin", "Manager", "Coordinator", "User"] // Acessível apenas para Admin
  // },
  // {
  //   imgSrc: newPerson,
  //   label: "Nova Pessoa",
  //   navigateTo: "/home/person/create",
  //   requiredRole: ["Admin", "Manager"] // Acessível apenas para Admin e Manager
  // },
  {
    imgSrc: allPersons,
    label: "Todos Pacientes",
    navigateTo: "/home/patient/get",
    requiredRole: AccessControl4
  },
  {
    imgSrc: newPerson,
    label: "Novo Paciente",
    navigateTo: "/home/patient/create",
    requiredRole: AccessControl2
  },
  {
    imgSrc: allPersons,
    label: "Todos Nutricionistas",
    navigateTo: "/home/nutritionist/get",
    requiredRole: AccessControl4
  },
  {
    imgSrc: newPerson,
    label: "Novo Nutricionista",
    navigateTo: "/home/nutritionist/create",
    requiredRole: AccessControl2
  },
  {
    imgSrc: allCompanies,
    label: "Todas Empresas",
    navigateTo: "/home/company/get",
    requiredRole: AccessControl4
  },
  {
    imgSrc: newCompany,
    label: "Nova Empresa",
    navigateTo: "/home/company/create",
    requiredRole: AccessControl3
  },
  {
    imgSrc: allAppointment,
    label: "Todos Agendamentos",
    navigateTo: "/home/appointment/get",
    requiredRole: AccessControl4
  },
  {
    imgSrc: newAppointment,
    label: "Novo Agendamento",
    navigateTo: "/home/appointment/create",
    requiredRole: AccessControl3
  },
  {
    imgSrc: allUsers,
    label: "Todos Usuários",
    navigateTo: "/home/user/get",
    requiredRole: AccessControl1
  },
  {
    imgSrc: newUser,
    label: "Novo Usuário",
    navigateTo: "/home/user/create",
    requiredRole: AccessControl1
  },
  {
    imgSrc: allFoods,
    label: "Todos Alimentos",
    navigateTo: "/home/nutridata/get/taco4foods",
    requiredRole: AccessControl3
  },
  {
    imgSrc: allFoods,
    label: "Novo Alimento",
    navigateTo: "/home/nutridata/create",
    requiredRole: AccessControl4
  },
  {
    imgSrc: anthropometry,
    label: "Antropometria",
    navigateTo: "/home/anthropometry/create",
    requiredRole: AccessControl3
  },
  {
    imgSrc: anthropometry,
    label: "Antropometria Por Paciente",
    navigateTo: "/home/anthropometry/get",
    requiredRole: AccessControl3
  },
  {
    imgSrc: consultation,
    label: "Todas Consultas",
    navigateTo: "/home/consultation/get",
    requiredRole: AccessControl1
  },
  // {
  //   imgSrc: draIcon,
  //   label: "Todos os profissionais",
  //   navigateTo: "/home/user/get",
  //   requiredRole: ["Admin", "Manager"] // Acessível apenas para Admin e Manager
  // },
  // {
  //   imgSrc: draIcon,
  //   label: "Novo Profissional",
  //   navigateTo: "/home/user/get",
  //   requiredRole: ["Admin", "Manager"] // Acessível apenas para Admin e Manager
  // },
];
